import { render, staticRenderFns } from "./FieldLabeling.vue?vue&type=template&id=558b27db&lang=pug"
import script from "./FieldLabeling.vue?vue&type=script&lang=js"
export * from "./FieldLabeling.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports